import { styled } from "@mui/material/styles";

const StyledSignUp = styled("div")`
  width: 100%;
  max-width: 500px;

  & > .sign-up__stepper {
    margin-bottom: 24px;
  }

  & > .sign-up__btn {
    margin-bottom: 24px;
  }
`;

const StyledSignUpHeadings = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    margin-bottom: 24px;
  }
`;

const StyledSignUpFields = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

const StyledInitialStep = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledStep = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;

  & > .step-uploader {
    margin-bottom: 16px;

    @media (min-width: 1024px) {
      margin-bottom: 24px;
    }
  }
`;

const StyledInitialStepAgreement = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
`;

export {
  StyledSignUp,
  StyledSignUpHeadings,
  StyledSignUpFields,
  StyledInitialStep,
  StyledInitialStepAgreement,
  StyledStep,
};
